import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FundraiserService } from '../../../services/fundraiser.service';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { ShareUpdateComponent } from '../../dialogs/updates/share-update/share-update.component';
import { MatDialog } from '@angular/material/dialog';
import { PageLoaderComponent } from '../../../../../shared/components/page-loader/page-loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { NgImageSliderModule } from 'ng-image-slider';
import { QuillViewComponent } from '../../../../../shared/components/quill-view/quill-view.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatDividerModule } from '@angular/material/divider';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { ImageSliderDialogComponent } from '../../dialogs/image-slider-dialog/image-slider-dialog.component';

@Component({
	selector: 'app-fundraiser-update-view',
	templateUrl: './fundraiser-update-view.component.html',
	standalone: true,
	imports: [
		NgIf,
		FlexModule,
		MatDividerModule,
		NgClass,
		ExtendedModule,
		NgFor,
		MatFormFieldModule,
		MatButtonModule,
		QuillViewComponent,
		NgImageSliderModule,
		MatIconModule,
		MatProgressSpinnerModule,
		PageLoaderComponent,
		ImageSliderDialogComponent,
	],
})
/** *Fundraiser Update View Component */
export class FundraiserUpdateViewComponent implements OnInit, OnChanges {
	@Input() fundraiserUpdates: any;
	@Input() currentFundraiser!: any;
	@Input() updatesList: any;
	@Input() cardShadow: string = '1';
	@Input() slug: any;
	@Input() count: any;
	@Input() totalPages: any;
	@Output() loadFullUpdateEvent = new EventEmitter<any>();
	readMoreSelectedId = 0;

	page: number = 1;
	loading: boolean = false;

	constructor(
		private _domSanitizer: DomSanitizer,
		private _fundraiserService: FundraiserService,
		private _accountService: AccountService,
		public dialog: MatDialog
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.fundraiserUpdates) {
			this.updatesList = this._fundraiserService.getUpdatesViewObj(
				this.fundraiserUpdates,
				this._accountService.getLocaleId()
			);
		}
	}

	ngOnInit(): void {}

	shareUpdate(index: number) {
		const dialogRef = this.dialog.open(ShareUpdateComponent, {
			maxHeight: '98vh',
			data: {
				update: this.updatesList[index],
				slug: this.currentFundraiser?.slug,
				currentFundraiser: this.currentFundraiser,
			},
		});
	}

	viewMore() {
		this.loading = true;
		this._fundraiserService
			.getUpdates(this.slug, this._accountService.getLocaleId(), this.page + 1)
			.subscribe((updatesData: any) => {
				const newUpdates = this._fundraiserService.getUpdatesViewObj(
					updatesData['data'],
					this._accountService.getLocaleId()
				);

				// Append the newUpdates to the existing updatesList
				this.updatesList = this.updatesList.concat(newUpdates);

				// Increment the page number for the next load
				this.page += 1;
				this.loading = false;
			});
	}

	loadFullUpdate(updatesId: any) {
		this.readMoreSelectedId = updatesId;
		this.loadFullUpdateEvent.emit(updatesId);
	}

	santizeURL(url: any) {
		return this._domSanitizer.bypassSecurityTrustResourceUrl(url);
	}

	hoverListItem(updates: any) {
		updates.listItemHovered = !updates.listItemHovered;
	}

	openCustomDialog(clickedImage: any, imageList: any): void {
		this.dialog.open(ImageSliderDialogComponent, {
			data: {
				images: imageList,
				clickedImage,
			},
			maxWidth: '95vw',
			width: '100%',
		});
	}
}
